import React from 'react';
import CertificationDaysOpenStatus from './CertificationDaysOpenStatus';

// NVBDC-1406 — extracted from the identical "Application ID: X <counter/>" line copy-pasted
// into every Veteran step file's header.
function VeteranAppIdHeader({ appId, daysOpen }) {
	return (
		<p className="pull-right cert-subTitle">
			Application ID: {appId} <CertificationDaysOpenStatus daysOpen={daysOpen} />
		</p>
	);
}

export default VeteranAppIdHeader;



// WEBPACK FOOTER //
// ./src/areas/shared/components/certificationDaysOpen/VeteranAppIdHeader.js